import { Injector, NgModuleRef, createNgModule } from "@angular/core";
import { PeopleModule } from "./people.module";

// ts-unused-exports:disable-next-line
export const lazyState = "gtmhub.teams.list";

let moduleInjector: Injector;

// ts-unused-exports:disable-next-line
export const getModuleInjector = (): Injector => moduleInjector;

// ts-unused-exports:disable-next-line
export const createModuleRef = (parentInjector: Injector): NgModuleRef<PeopleModule> => {
  const moduleRef = createNgModule(PeopleModule, parentInjector);
  moduleInjector = moduleRef.injector;
  return moduleRef;
};

// ts-unused-exports:disable-next-line
export const getNg1Module = (): Promise<string> => import(/* webpackMode: "eager" */ "@gtmhub/people/people.module").then((x) => x.default);
